__turbopack_context__.v({
  "badge": "styles-module-scss-module__4DCCLW__badge",
  "badge__modLookingGood": "styles-module-scss-module__4DCCLW__badge__modLookingGood",
  "badge__modNeedsAttention": "styles-module-scss-module__4DCCLW__badge__modNeedsAttention",
  "badge__modWorthLook": "styles-module-scss-module__4DCCLW__badge__modWorthLook",
  "scoreBreakdown": "styles-module-scss-module__4DCCLW__scoreBreakdown",
  "scoreBreakdown__breakdown": "styles-module-scss-module__4DCCLW__scoreBreakdown__breakdown",
  "scoreBreakdown__breakdownDescription": "styles-module-scss-module__4DCCLW__scoreBreakdown__breakdownDescription",
  "scoreBreakdown__breakdownHeader": "styles-module-scss-module__4DCCLW__scoreBreakdown__breakdownHeader",
  "scoreBreakdown__breakdownTitle": "styles-module-scss-module__4DCCLW__scoreBreakdown__breakdownTitle",
  "scoreBreakdown__downloadButton": "styles-module-scss-module__4DCCLW__scoreBreakdown__downloadButton",
  "scoreBreakdown__downloadIcon": "styles-module-scss-module__4DCCLW__scoreBreakdown__downloadIcon",
  "scoreBreakdown__row": "styles-module-scss-module__4DCCLW__scoreBreakdown__row",
  "scoreBreakdown__rowLabel": "styles-module-scss-module__4DCCLW__scoreBreakdown__rowLabel",
  "scoreBreakdown__rowScore": "styles-module-scss-module__4DCCLW__scoreBreakdown__rowScore",
  "scoreBreakdown__rows": "styles-module-scss-module__4DCCLW__scoreBreakdown__rows",
  "scoreBreakdown__topRow": "styles-module-scss-module__4DCCLW__scoreBreakdown__topRow",
  "scoreBreakdown__topRow_greeting": "styles-module-scss-module__4DCCLW__scoreBreakdown__topRow_greeting",
  "scoreBreakdown__topRow_headline": "styles-module-scss-module__4DCCLW__scoreBreakdown__topRow_headline",
  "scoreBreakdown__topRow_hero": "styles-module-scss-module__4DCCLW__scoreBreakdown__topRow_hero",
});
